// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__1Jeq5","errors":"Errors_errors__rgT1r"};